var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"rectangle-1"}),_c('div',{staticClass:"rectangle-2"}),_c('div',{staticClass:"rectangle-3"}),_c('div',{staticClass:"rectangle-4"}),_c('div',{staticClass:"rectangle-3"}),_c('div',{staticClass:"rectangle-2"}),_c('div',{staticClass:"rectangle-1"})])
}]

export { render, staticRenderFns }